






































































































































































































































































































































































































































































































































































































































































































































































































































































































































import {
  Component,
  Vue,
  Watch,
  Prop,
  Ref,
  PropSync,
} from "vue-property-decorator";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import CurrencyDisplay from "@/components/misc/CurrencyDisplay.vue";
import FormDescription from "@/components/misc/FormDescription.vue";
import { ListModel } from "@/shared/models/listModel";
import {
  RatePlanModel,
  RatePlanOtas,
  NonDerivedRatePlanModel,
  RatePlanTranslation,
  RatePlanChangedFields,
  UnitTypeViewModel,
  RatePlanOccupancyBasedRule,
  RatePlanAccomodationUnitType,
} from "@/shared/models/ratePlanModel";
import { ServiceType } from "@/shared/models/serviceType";
import { PrepaymentPolicy } from "@/shared/models/prepaymentPolicy";
import { CancelationPolicy } from "@/shared/models/cancelationPolicy";
import { Ota } from "@/shared/models/ota";
import { AppParam, AppParamsEnum } from "@/shared/models/appParam";
import { Action, Getter } from "vuex-class";
import * as _ from "lodash";
import NoData from "@/components/misc/NoData.vue";
import { LanguageView } from "@/shared/models/languages";
import HTMLPreviewModal from "@/components/misc/HTMLPreviewModal.vue";
import DateField from "@/components/misc/DateField.vue";
import { Notification } from "@/store/modules/notifications";
import RatePlanFormAddOnServices from "@/components/RatePlanFormAddOnServices.vue";
import RichTextEditor from "@/components/misc/RichTextEditor.vue";
import { Currency } from "@/shared/models/currency";
import PriceInput, { PriceChange } from "./calendar/inputs/PriceInput.vue";
import { FinancialSettingsType } from "@/store/modules/financial";
import { RatePlansPromoCodeApplicationMethod } from "@/shared/models/ratePlansPromoCodeApplicationMethod";
import { RatePlansPromoCodeApplicationMethodsEnum } from "@/shared/models/enums.type";
import handleBrokenRuleAdapter from "@/shared/handleBrokenRuleAdapter";
import PhotoForm from "./photo-editor/PhotoForm.vue";
import { PhotoViewModel } from "./photo-editor/types";
import NumericInputImproved from "./numbers/NumericInputImproved.vue";

@Component({
  components: {
    RightDrawer,
    FormDescription,
    CurrencyDisplay,
    NoData,
    HTMLPreviewModal,
    DateField,
    RatePlanFormAddOnServices,
    RichTextEditor,
    PriceInput,
    PhotoForm,
    NumericInputImproved,
  },
})
export default class RatePlanForm extends Vue {
  //#region props, getters and actions
  @Prop({ default: null }) ratePlanId!: number | null;
  @PropSync("parentRatePlanId", { default: null }) internalParentRatePlanId!:
    | number
    | null;
  @Prop({ default: false }) open!: boolean;
  @Prop() callback!: () => any;

  @Getter("appParams/tenantOBRsUseRelativePricing")
  tenantOBRsUseRelativePricing?: boolean;

  @Getter("appParams/tenantCanEditLOSCategories")
  tenantCanEditLOSCategories?: boolean;

  @Action("codebooks/refreshCurrencies")
  refreshCurrencies?: () => Promise<void>;
  @Getter("codebooks/currencies") currencies?: Currency[];

  @Action("codebooks/refreshRatePlansPromoCodeApplicationMethods")
  refreshRatePlansPromoCodeApplicationMethods?: () => Promise<void>;
  @Getter("codebooks/ratePlansPromoCodeApplicationMethods")
  ratePlansPromoCodeApplicationMethods?: RatePlansPromoCodeApplicationMethod[];

  @Getter("language/language") language?: string;
  get internalLanguage() {
    return this.language ?? "hr-HR";
  }

  @Getter("financial/settings") storedSettings?: FinancialSettingsType;
  @Action("financial/refreshModel") refreshSettings?: () => Promise<void>;

  @Getter("appParams/appParams") appParams?: AppParam[];
  @Getter("appParams/workingCurrency") workingCurrency?: Currency;
  @Getter("appParams/asyncRatePlanAvailabiltyUpdateThresholdSize")
  asyncRatePlanAvailabiltyUpdateThresholdSize?: number;

  @Action("codebooks/refreshPrepaymentPolicies")
  refreshPrepaymentPolicies?: () => Promise<void>;
  @Getter("codebooks/prepaymentPolicies")
  prepaymentPolicies?: PrepaymentPolicy[];

  @Action("codebooks/refreshCancelationPolicies")
  refreshCancelationPolicies?: () => Promise<void>;
  @Getter("codebooks/cancelationPolicies")
  cancelationPolicies?: CancelationPolicy[];

  @Action("codebooks/refreshServiceTypes")
  refreshServiceTypes?: () => Promise<void>;
  @Getter("codebooks/serviceTypes")
  serviceTypes?: ServiceType[];

  // prettier-ignore
  @Action("codebooks/refreshLanguages") refreshLanguages?: () => Promise<void>;
  @Getter("codebooks/languages") languages?: LanguageView[];
  //#endregion

  //#region properties
  @Ref("drawer") rightDrawer?: RightDrawer;

  tab = 0;
  fkey = 0;
  photoFormOpen = false;

  initialRatePlan: RatePlanModel = new RatePlanModel();
  ratePlan = new RatePlanModel();

  OTAs: Ota[] = [];
  nonDerivedRatePlans: NonDerivedRatePlanModel[] = [];

  //#endregion

  //#region computed properties
  get tenantUsesServiceType() {
    const param = this.appParams?.find(
      (x) => x.id == AppParamsEnum.ReservationTenantUsesServiceTypes
    );
    return param && param.value;
  }

  get tenantUsesInstalments() {
    const param = this.appParams?.find(
      (x) => x.id === AppParamsEnum.TenantUsesInstalments
    );
    return param && param.value;
  }

  get tenantUsesBookingFees() {
    const param = this.appParams?.find(
      (x) => x.id === AppParamsEnum.TenantUsesBookingFees
    );
    return param && param.value;
  }

  get applyRatePlansToAllAccomodationUnitTypes() {
    const param = this.appParams?.find(
      (x) => x.id == AppParamsEnum.ApplyRatePlansToAllAccomodationUnitTypes
    );
    return param && param.value;
  }

  get currenciesForSelect() {
    //for now only HRK and EUR
    return this.currencies?.filter(
      (x) =>
        x.id == this.storedSettings?.workingCurrency.id ||
        x.id == this.storedSettings?.formalCurrency.id
    );
  }

  get parentRatePlanName() {
    return (
      this.nonDerivedRatePlans.find(
        (x) => x.id == this.ratePlan.parentRatePlanId
      )?.name || ""
    );
  }

  get canEditAppliesToAllAUT() {
    return (
      this.nonDerivedRatePlans.find(
        (x) =>
          x.id === this.ratePlan.parentRatePlanId && this.ratePlan.isDerived
      )?.appliesToAllAccomodationUnitTypes ?? true
    );
  }

  get channels() {
    if (!this.ratePlan && !this.OTAs) {
      return [];
    }

    const res: RatePlanOtas[] = [];
    res.push(...this.ratePlan.ratePlanOtas);

    const missing = this.OTAs.filter(
      (x) => !res.some((y) => y.otaid == x.id)
    ).map((x) => {
      return {
        otaid: x.id,
        name: x.name,
        priceDifference: null,
      };
    });
    res.push(...missing);

    return res.sort((a, b) => a.otaid - b.otaid);
  }

  get priceDifferenceItems() {
    return [
      {
        text: this.$t("RatePlan.IsPriceDifferenceAbsolute"),
        value: true,
      },
      {
        text: this.$t("RatePlan.IsPriceDifferencePercentage"),
        value: false,
      },
    ];
  }
  //#endregion

  //#region lifecycle
  async created() {
    this.setUpRules();

    const promises = [];

    if ((this.currencies?.length ?? 0) === 0 && this.refreshCurrencies) {
      promises.push(this.refreshCurrencies());
    }

    if (
      (this.ratePlansPromoCodeApplicationMethods?.length ?? 0) === 0 &&
      this.refreshRatePlansPromoCodeApplicationMethods
    ) {
      promises.push(this.refreshRatePlansPromoCodeApplicationMethods());
    }

    if (!this.storedSettings && this.refreshSettings) {
      promises.push(this.refreshSettings());
    }

    await Promise.all(promises);
  }

  mounted() {
    this.loadOTAs();
    this.loadNonDerivedRatePlans();

    if (
      (this.prepaymentPolicies?.length ?? 0) === 0 &&
      this.refreshPrepaymentPolicies
    ) {
      this.refreshPrepaymentPolicies();
    }
    if (
      (this.cancelationPolicies?.length ?? 0) === 0 &&
      this.refreshCancelationPolicies
    ) {
      this.refreshCancelationPolicies();
    }
    if ((this.serviceTypes?.length ?? 0) === 0 && this.refreshServiceTypes) {
      this.refreshServiceTypes();
    }

    if ((this.languages?.length ?? 0) === 0 && this.refreshLanguages) {
      this.refreshLanguages();
    }
  }
  //#endregion

  //#region validation and sanitation
  isFormValid = false;
  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  get submitDisabled(): boolean {
    const promoCodeValid =
      !this.ratePlan.promoCode ||
      this.ratePlan.promoCode.isForAccommodation ||
      this.ratePlan.promoCode.isForService;
    return this.loading || this.saving || !promoCodeValid || !this.isFormValid;
  }

  rules = {};
  setUpRules() {
    this.rules = {
      Required: [(value: any) => !!value || this.$t("Validation.Required")],
      RequiredArray: [
        (value: any[]) => value.length > 0 || this.$t("Validation.Required"),
      ],
      WholeNumbersOnly: [
        (value: number) =>
          value == null ||
          value == undefined ||
          value % 1 == 0 ||
          this.$t("Validation.MustBeWholeNumber"),
      ],
      NoNegativeNumbers: (value: number) =>
        value == null ||
        value == undefined ||
        value >= 0 ||
        this.$t("Validation.MustBePositive"),
      MustBeNegativeAbsolute: (value: string) =>
        value == null ||
        value == undefined ||
        parseInt(value) <= 0 ||
        !this.ratePlan.promoCode?.priceDifferenceIsAbsolute ||
        this.$t("Validation.MustBeNegativeWhenAbsolute"),
      OneOrGreater: (value: number) =>
        value == null ||
        value == undefined ||
        value >= 1 ||
        this.$t("Validation.MustBeOneOrGreater"),
      NotEqual: (value: number, x: number) =>
        value != x || this.$t("Validation.NotEqual", { value: x }),
      LessOrEqual: (value: number, x: number) =>
        value <= x || this.$t("Validation.LessOrEqual", { value: x }),
      GreaterThanMinus100: (
        value: number,
        priceDifferenceIsAbsolute: boolean
      ) =>
        value === null ||
        value === undefined ||
        value > -100 ||
        priceDifferenceIsAbsolute ||
        this.$t("Validation.MinValue"),
      FromDateBeforeUntilDate: (dateFrom: Date, dateUntil: Date) =>
        !(dateFrom && dateUntil && dateFrom > dateUntil) ||
        this.$t("AddOnService.Validation.DateFromBeforeDateUntil")
    };
  }

  maxLength(max: number) {
    return (v: string) =>
      !v || v.length <= max
        ? true
        : this.$t("Validation.MaxLength", { count: max });
  }

  maxDecimals(value: any) {
    if (value !== undefined) {
      return !(this.countDecimals(value) > 2)
        ? true
        : this.$t("Validation.MaxDecimals{max}", {
            max: 2,
          });
    } else {
      return true;
    }
  }

  get decimalSeparator() {
    const separator = Intl.NumberFormat(this.internalLanguage)
      .format(1.1)
      .replace(/\p{Number}/gu, "");
    return separator;
  }

  countDecimals(num: number) {
    return num.toString().split(this.decimalSeparator)[1]?.length || 0;
  }

  get promoCodeCheckboxesErrors() {
    if (
      this.ratePlan.promoCode?.isForAccommodation ||
      this.ratePlan.promoCode?.isForService
    )
      return [];

    return [
      this.$t("RatePlan.PromoCode.AppliesToAccomodationOrService").toString(),
    ];
  }

  validate() {
    this.form.validate();

    if (!this.isFormValid) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Changes are invalid or incomplete"),
        timeout: 5000,
      });

      return;
    }
  }

  // v-model on inputs, when cleared, sets the value to '' rather than null or undefined
  // which causes errors as BL expects numbers and not strings
  sanitizeRatePlanModel(ratePlan: RatePlanModel) {
    ratePlan.minimumStay =
      ratePlan.minimumStay?.toString() === ""
        ? undefined
        : ratePlan.minimumStay;
    ratePlan.maximumStay =
      ratePlan.maximumStay?.toString() === ""
        ? undefined
        : ratePlan.maximumStay;
    ratePlan.minBookableBeforeCheckin =
      ratePlan.minBookableBeforeCheckin?.toString() === ""
        ? undefined
        : ratePlan.minBookableBeforeCheckin;
    ratePlan.maxBookableBeforeCheckin =
      ratePlan.maxBookableBeforeCheckin?.toString() === ""
        ? undefined
        : ratePlan.maxBookableBeforeCheckin;

    ratePlan.priceDifference = !ratePlan.priceDifference
      ? 0
      : ratePlan.priceDifference;

    ratePlan.bookingEnginePriceOffset =
      ratePlan.bookingEnginePriceOffset?.toString() === ""
        ? undefined
        : ratePlan.bookingEnginePriceOffset;

    ratePlan.ratePlanOtas.forEach((e) => {
      e.priceDifference =
        e.priceDifference?.toString() === "" ? null : e.priceDifference;
    });

    ratePlan.bookableFrom =
      ratePlan.bookableFrom === "" ? undefined : ratePlan.bookableFrom;
    ratePlan.bookableUntil =
      ratePlan.bookableUntil === "" ? undefined : ratePlan.bookableUntil;
    ratePlan.arrivalDateFrom =
      ratePlan.arrivalDateFrom === "" ? undefined : ratePlan.arrivalDateFrom;
    ratePlan.arrivalDateUntil =
      ratePlan.arrivalDateUntil === "" ? undefined : ratePlan.arrivalDateUntil;
    ratePlan.maxSellableNights =
      ratePlan.maxSellableNights?.toString() === ""
        ? undefined
        : ratePlan.maxSellableNights;
    ratePlan.maxSellableReservations =
      ratePlan.maxSellableReservations?.toString() === ""
        ? undefined
        : ratePlan.maxSellableReservations;
  }
  //#endregion

  //#region loading
  loading = false;

  @Watch("open")
  async openWatch(fresh: boolean, old: boolean) {
    if (fresh && !old) {
      this.fkey++;
      this.tab = 0;
    }

    if (fresh && this.ratePlanId) {
      this.initialRatePlan = new RatePlanModel();
      await this.load();
      if (this.internalParentRatePlanId) {
        await this.loadParent();
      }
    } else if (fresh && this.internalParentRatePlanId) {
      this.initialRatePlan = new RatePlanModel();
      await this.loadParent();
      this.createDerived();
    } else if (fresh) {
      this.ratePlan = new RatePlanModel();
      this.ratePlan.currencyId = this.storedSettings?.workingCurrency.id;

      if (this.applyRatePlansToAllAccomodationUnitTypes) {
        this.selectAllUnitTypes();
      }

      this.initialRatePlan = _.cloneDeep(this.ratePlan);

      this.expandedTranslation = null;
      this.previewHtml = "";
      this.photoSrc = "";
      this.ratePlan.promoCode = null;
      this.showPromoCode = false;
      this.initialPromoCodePrice = "";
    }

    if (fresh) {
      this.loading = true;
      const promises = [];
      promises.push(this.loadNonDerivedRatePlans());
      promises.push(this.loadAccomodationUnitTypes());
      await Promise.all(promises);
      this.selectUnitTypeRange(this.ratePlan.accomodationUnitTypeIds);
      this.loading = false;
    }

    if (!fresh) {
      this.showPromoCode = false;
      this.ratePlan = new RatePlanModel();
      this.selectedUnitTypes = [];
      this.availableUnitTypes = [];
      this.occupancyBasedRules = [];
      this.unitTypesFilter = "";
      this.occupancyBasedRulesFilter = "";
    }
  }

  async load() {
    this.loading = true;

    await Vue.axios
      .get<RatePlanModel>("RatePlans/" + this.ratePlanId)
      .then((res) => {
        this.ratePlan = {
          ...new RatePlanModel(),
          ...res.data,
        };
        this.ratePlan.changedFields = new RatePlanChangedFields();

        if (this.ratePlan.parentRatePlanId) {
          this.internalParentRatePlanId = this.ratePlan.parentRatePlanId;
        }

        this.initialRatePlan = _.cloneDeep(this.ratePlan);

        this.loading = false;

        if (this.ratePlan.hasPhoto) {
          this.loadPhoto();
        }

        this.formatInitialPromoCodePrice();

        this.showPromoCode = !!this.ratePlan.promoCode;

        this.loading = false;
      });
  }

  parentRatePlan: RatePlanModel | null = null;
  async loadParent() {
    this.loading = true;

    await Vue.axios
      .get<RatePlanModel>("RatePlans/" + this.internalParentRatePlanId)
      .then((res) => {
        this.parentRatePlan = res.data;
        this.loading = false;
      });
  }

  createDerived() {
    if (this.parentRatePlan) {
      this.ratePlan = _.cloneDeep(this.parentRatePlan);

      this.ratePlan.changedFields = new RatePlanChangedFields();

      this.ratePlan.isDerived = true;
      this.ratePlan.parentRatePlanId = this.ratePlan.id;
      this.ratePlan.id = undefined;
      this.ratePlan.name = "";
      Vue.set(this.ratePlan, "priceDifferenceIsAbsolute", false);
      Vue.set(this.ratePlan, "priceDifference", 0);

      this.ratePlan.translations.forEach((element) => {
        const translationsLength = this.ratePlan.translations.length;
        const index = this.ratePlan.translations.findIndex(
          () => element.translation
        );
        if (index != -1) {
          this.ratePlan.translations.splice(index, translationsLength);
        }
      });

      this.initialRatePlan = _.cloneDeep(this.ratePlan);

      this.showPromoCode = this.ratePlan.promoCode != undefined;

      this.loading = false;
    }
  }

  loadOTAs() {
    Vue.axios.get<ListModel<Ota>>("OTAs").then((res) => {
      this.OTAs = res.data.result;
    });
  }

  async loadNonDerivedRatePlans() {
    return Vue.axios
      .get<ListModel<NonDerivedRatePlanModel>>(
        "RatePlans/GetNonDerivedRatePlans"
      )
      .then((res) => {
        this.nonDerivedRatePlans = res.data.result;

        // in case derived is clicked and nonDerived were slow lo load :/
        if (
          this.ratePlan &&
          this.ratePlan.isDerived &&
          this.nonDerivedRatePlans &&
          this.nonDerivedRatePlans.length === 1
        ) {
          this.ratePlan.parentRatePlanId = this.nonDerivedRatePlans[0].id;
        }
      });
  }

  loadPhoto() {
    Vue.axios
      .get<PhotoViewModel>("RatePlans/" + this.ratePlan.id + "/photo/details")
      .then((res) => {
        this.photo = res.data;
      });

    Vue.axios
      .get("RatePlans/" + this.ratePlan.id + "/Photo?width=420&quality=95", {
        responseType: "blob",
      })
      .then((res) => {
        const reader = new FileReader();
        reader.readAsDataURL(res.data);
        reader.onload = () => {
          this.photoSrc = reader.result;
        };
      })
      .catch(() => {
        this.photoSrc = require("@/assets/images/no-image-icon-23488.png");
      });
  }

  async loadAccomodationUnitTypes() {
    return Vue.axios
      .get<UnitTypeViewModel[]>("AccomodationUnitTypes/GetForRatePlanForm")
      .then((res) => {
        this.availableUnitTypes = res.data.filter(
          (x) =>
            !this.ratePlan.isDerived ||
            this.parentRatePlan?.accomodationUnitTypeIds.includes(
              x.accomodationUnitTypeId
            )
        );
      });
  }
  //#endregion

  //#region submit
  saving = false;

  get showSaveAndUpdateButton() {
    let existingOBRs = this.ratePlan.ratePlanAccomodationUnitTypes.map((x) => {
      return {
        accomodationUnitTypeId: x.accomodationUnitTypeId,
        accomodationUnitTypesLOSCategoryId:
          x.accomodationUnitTypesLOSCategoryId,
        accomodationUnitTypesPAXCategoryId:
          x.accomodationUnitTypesPAXCategoryId,
        priceDifference: x.priceDifference,
        priceDifferenceIsAbsolute: x.priceDifferenceIsAbsolute ?? false,
      } as RatePlanAccomodationUnitType;
    });

    let currentOBRs = !this.tenantOBRsUseRelativePricing
      ? []
      : this.occupancyBasedRules.map((x) => {
          return {
            accomodationUnitTypeId: x.accomodationUnitTypeId,
            accomodationUnitTypesLOSCategoryId:
              x.accomodationUnitTypesLOSCategoryId,
            accomodationUnitTypesPAXCategoryId:
              x.accomodationUnitTypesPAXCategoryId,
            priceDifference: x.priceDifference,
            priceDifferenceIsAbsolute: x.priceDifferenceIsAbsolute ?? false,
          } as RatePlanAccomodationUnitType;
        });

    currentOBRs = currentOBRs.filter((c) =>
      existingOBRs.some(
        (e) =>
          e.accomodationUnitTypeId === c.accomodationUnitTypeId &&
          e.accomodationUnitTypesPAXCategoryId ===
            c.accomodationUnitTypesPAXCategoryId &&
          e.accomodationUnitTypesLOSCategoryId ===
            c.accomodationUnitTypesLOSCategoryId
      )
    );

    existingOBRs = _.sortBy(
      existingOBRs,
      (e) => e.accomodationUnitTypeId,
      (e) => e.accomodationUnitTypesPAXCategoryId,
      (e) => e.accomodationUnitTypesLOSCategoryId
    );
    currentOBRs = _.sortBy(
      currentOBRs,
      (e) => e.accomodationUnitTypeId,
      (e) => e.accomodationUnitTypesPAXCategoryId,
      (e) => e.accomodationUnitTypesLOSCategoryId
    );

    return (
      this.ratePlan.changedFields.minStay ||
      this.ratePlan.changedFields.maxStay ||
      this.ratePlan.changedFields.minBookable ||
      this.ratePlan.changedFields.maxBookable ||
      this.ratePlan.changedFields.priceDiffType ||
      this.ratePlan.changedFields.priceDiff ||
      !_.isEqual(currentOBRs, existingOBRs)
    );
  }

  get actions() {
    return [
      {
        text: this.$t("Save"),
        fun: () => {
          this.submit();
          return true;
        },
      },
      ...(this.showSaveAndUpdateButton
        ? [
            {
              text: this.$t("Save and update"),
              fun: () => {
                this.ratePlan.updateExistingAvailability = true;
                this.submit();
                return true;
              },
            },
          ]
        : []),
      {
        text: this.$t("Cancel"),
        fun: () => {
          return true;
        },
      },
    ];
  }

  priceDiffChanged() {
    this.ratePlan.changedFields.priceDiff = true;
  }

  minStayChanged() {
    this.ratePlan.changedFields.minStay = true;
  }

  maxStayChanged() {
    this.ratePlan.changedFields.maxStay = true;
  }

  minBookableChanged() {
    this.ratePlan.changedFields.minBookable = true;
  }

  maxBookableChanged() {
    this.ratePlan.changedFields.maxBookable = true;
  }

  submitConfirm() {
    if (
      this.ratePlan.id &&
      this.ratePlan.id !== 0 &&
      this.showSaveAndUpdateButton
    ) {
      this.$store.dispatch("showNotification", {
        color: "warning",
        message: this.$t("RatePlan.UpdateConfirmation"),
        actions: this.actions,
        timeout: 30000,
      } as Notification);
    } else {
      this.submit();
    }
  }

  submit(overrides: string[] = []) {
    this.sanitizeRatePlanModel(this.ratePlan);

    this.validate();

    if (_.isEmpty(this.ratePlan.promoCode)) {
      this.ratePlan.promoCode = null;
    }

    if (!this.isFormValid) {
      return;
    }

    const requestRatePlanModel = {
      ...this.ratePlan,
      accomodationUnitTypeIds: this.selectedUnitTypes.map(
        (e) => e.accomodationUnitTypeId
      ),
      ratePlanAccomodationUnitTypes: !this.tenantOBRsUseRelativePricing
        ? []
        : this.occupancyBasedRules,
    };

    //submit
    this.saving = true;
    if (this.ratePlan.id && this.ratePlan.id !== 0) {
      const handleCodes = ["RatePlan.DeleteValidation.OtaSync"];
      const adapter = handleBrokenRuleAdapter(this.axios, handleCodes);

      // prettier-ignore
      const formatBrokenRuleNames = (x: string[]) => x
      .map((h) => this.$t(h).toString())
      .map((th) => th.endsWith(".") ? th : th + ".")
      .join(" ");

      const isOverriding = overrides.length !== 0;

      Vue.axios
        .put(
          "/RatePlans",
          { ...requestRatePlanModel, overrideRules: overrides },
          {
            adapter: isOverriding ? undefined : adapter,
          }
        )
        .then(() => {
          this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("RatePlan.SaveSuccess"),
            timeout: 5000,
          });

          // Only show the message if the calendar availability update will be done async
          if (
            this.asyncRatePlanAvailabiltyUpdateThresholdSize &&
            this.selectedUnitTypesCount >
              this.asyncRatePlanAvailabiltyUpdateThresholdSize &&
            (this.areNewAUTsSelected(
              this.initialSelectedUnitTypes,
              this.selectedUnitTypes
            ) ||
              (this.ratePlan.updateExistingAvailability &&
                requestRatePlanModel.changedFields &&
                (requestRatePlanModel.changedFields.maxBookable ||
                  requestRatePlanModel.changedFields.minBookable ||
                  requestRatePlanModel.changedFields.maxStay ||
                  requestRatePlanModel.changedFields.minStay ||
                  requestRatePlanModel.changedFields.priceDiff ||
                  requestRatePlanModel.changedFields.priceDiffType)))
          ) {
            this.$store.dispatch("showNotification", {
              color: "success",
              message: this.$t(
                "RatePlan.AsyncRatePlanAvailabilityUpdateStarted"
              ),
              timeout: 10000,
            });
          }

          this.$emit("update:open", false);
          this.$store.dispatch("calendar/refreshRatePlans", undefined, {
            root: true,
          });
          this.callback();
        })
        .catch((x) => {
          if (x && x.isHandleBrokenRuleResult && !isOverriding) {
            this.$store.dispatch("showNotification", {
              color: "warning",
              message:
                // prettier-ignore
                `${formatBrokenRuleNames(x.handled)} ${this.$t("Do you wish to continue anyway?")}`,
              timeout: 30000,
              actions: [
                {
                  text: this.$t("Yes"),
                  fun: () => {
                    this.submit(x.handled);
                    return true;
                  },
                },
                { text: this.$t("Cancel"), fun: () => true },
              ],
            } as Notification);
          } else {
            this.$store.dispatch("showNotification", {
              color: "error",
              message: `${formatBrokenRuleNames(x.unhandled)}`,
              timeout: 5000,
            } as Notification);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    } else {
      Vue.axios
        .post("/RatePlans", requestRatePlanModel)
        .then((res) => {
          this.ratePlan.id = res.data;

          this.initialRatePlan = _.cloneDeep(this.ratePlan);

          this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("RatePlan.SaveSuccess"),
            timeout: 5000,
          });

          // Only show the message if the calendar availability update will be done async
          if (
            this.asyncRatePlanAvailabiltyUpdateThresholdSize &&
            this.selectedUnitTypesCount >
              this.asyncRatePlanAvailabiltyUpdateThresholdSize
          ) {
            this.$store.dispatch("showNotification", {
              color: "success",
              message: this.$t(
                "RatePlan.AsyncRatePlanAvailabilityUpdateStarted"
              ),
              timeout: 10000,
            });
          }

          this.$emit("update:open", false);
          this.$store.dispatch("calendar/refreshRatePlans", undefined, {
            root: true,
          });
          this.callback();
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
  //#endregion

  //#region translations
  expandedTranslation = null as number | null;
  previewHtml = "";
  openPreview = false;

  addTranslation() {
    this.ratePlan.translations.push({
      id: 0,
      cultureCode: "",
      translation: "",
      subtitleTranslation: "",
      descriptionTranslation: "",
    });
  }

  removeTranslation(translation: RatePlanTranslation) {
    const index = this.ratePlan.translations.findIndex((x) => x == translation);
    if (index != -1) {
      this.ratePlan.translations.splice(index, 1);
    }
  }
  //#endregion

  //#region promo codes
  showPromoCode = false;
  initialPromoCodePrice = "";

  promoPriceDiffChange: PriceChange = {
    value: null,
    percentage: false,
    addition: false,
    subtraction: false,
    valid: true,
  };

  onPriceChanged(change: PriceChange) {
    Object.assign(this.promoPriceDiffChange, change);
    if (this.ratePlan.promoCode && (change.value || change.value === 0)) {
      this.ratePlan.promoCode.priceDifference = change.subtraction
        ? change.value * -1
        : change.value;
      this.ratePlan.promoCode.priceDifferenceIsAbsolute = !change.percentage;
    }
  }

  formatInitialPromoCodePrice() {
    if (
      this.ratePlan.promoCode?.priceDifference ||
      this.ratePlan.promoCode?.priceDifference === 0
    ) {
      this.initialPromoCodePrice =
        this.ratePlan.promoCode.priceDifference.toString();
      this.initialPromoCodePrice += !this.ratePlan.promoCode
        .priceDifferenceIsAbsolute
        ? "%"
        : "";
    }
  }

  addPromoCode() {
    this.showPromoCode = true;
    if (!this.ratePlan.promoCode) {
      this.ratePlan.promoCode = {
        id: 0,
        name: "",
        currencyId: this.ratePlan.currencyId,
        applicationMethodId:
          RatePlansPromoCodeApplicationMethodsEnum.OnlyWithCode,
        priceDifference: null,
        priceDifferenceIsAbsolute: false,
        isForService: false,
        isForAccommodation: true,
      };
    }
  }

  removePromoCode() {
    this.showPromoCode = false;
    this.ratePlan.promoCode = null;
    this.initialPromoCodePrice = "";
  }
  //#endregion

  //#region photos
  photo: PhotoViewModel | null = null;
  savingPhoto = false;
  dragging = false;
  filesToUpload: any = {};
  photoSrc: any = "";

  openPhotoForm() {
    this.photoFormOpen = true;
  }

  addPhoto() {
    (
      (this.$refs.photoInputRef as Vue).$el.lastElementChild?.firstElementChild
        ?.firstElementChild?.lastElementChild as HTMLElement
    ).click();
  }

  dropPhoto(e: any) {
    this.dragging = false;

    const imageTypeRegex = new RegExp(/image\/*/);

    for (const file of e.dataTransfer.files) {
      if (!imageTypeRegex.test(file.type)) {
        this.$store.dispatch("showNotification", {
          color: "error",
          message: this.$t("PhotosUpload.NotAllImages"),
          timeout: 5000,
        } as Notification);
        return;
      }
    }
    this.filesToUpload = e.dataTransfer.files;
  }

  @Watch("filesToUpload")
  uploadPhoto() {
    if (!this.ratePlan.id) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("RatePlans.MustBeSavedFirst"),
        timeout: 5000,
      } as Notification);
    }
    if (this.filesToUpload.length > 1) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("PhotosUpload.CannotUploadMultiplePhotos"),
        timeout: 5000,
      } as Notification);
      return;
    }

    if (!this.filesToUpload || this.filesToUpload.length == 0) {
      return;
    }

    const formData = new FormData();
    if (this.filesToUpload.length) {
      for (let i = 0; i < this.filesToUpload.length; i++) {
        formData.append("images", this.filesToUpload[i]);
      }
    } else {
      formData.append("images", this.filesToUpload);
    }

    this.savingPhoto = true;
    Vue.axios
      .post(`RatePlans/${this.ratePlan.id}/photos`, formData)
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("PhotosUpload.Success"),
          timeout: 5000,
        } as Notification);

        this.ratePlan.hasPhoto = true;
        this.loadPhoto();
      })
      .finally(() => (this.savingPhoto = false));
  }

  deletePhotoConfirmation() {
    this.$store.dispatch("showNotification", {
      color: "warning",
      message: this.$t("PhotoDelete.Confirmation"),
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.deletePhoto();
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }

  deletePhoto() {
    this.savingPhoto = true;
    Vue.axios
      .delete("RatePlans/" + this.ratePlan.id + "/Photo")
      .then(() => {
        this.ratePlan.hasPhoto = false;
      })
      .catch(() => {
        this.$store.dispatch("showNotification", {
          color: "error",
          message: this.$t("PhotoDelete.Failed"),
          timeout: 5000,
        } as Notification);
      })
      .finally(() => {
        this.savingPhoto = false;
      });
  }
  //#endregion

  //#region unit types
  availableUnitTypes = [] as UnitTypeViewModel[];
  selectedUnitTypes = [] as UnitTypeViewModel[];
  initialSelectedUnitTypes = [] as UnitTypeViewModel[];
  unitTypesFilter = "";

  unitTypeHeaders = [
    {
      text: "Property",
      value: "propertyName",
    },
  ];

  get translatedUnitTypeHeaders() {
    return this.unitTypeHeaders.map((x) => ({
      ...x,
      text: this.$t(x.text),
    }));
  }

  get filteredUnitTypes() {
    if (!this.unitTypesFilter) return this.availableUnitTypes;

    return this.availableUnitTypes.filter((x) =>
      x.propertyName.toLowerCase().includes(this.unitTypesFilter.toLowerCase())
    );
  }

  get selectedUnitTypesCount() {
    return this.selectedUnitTypes.length;
  }

  areAllUnitTypeselected() {
    return !this.filteredUnitTypes.some(
      (e) => this.selectedUnitTypes.indexOf(e) === -1
    );
  }
  selectAllUnitTypes() {
    if (this.areAllUnitTypeselected()) {
      this.selectedUnitTypes = [];
    } else {
      const unselected = this.filteredUnitTypes.filter(
        (e) => this.selectedUnitTypes.indexOf(e) === -1
      );
      this.selectedUnitTypes = this.selectedUnitTypes.concat(unselected);
    }
  }

  selectUnitTypeRange(ids: number[]) {
    this.selectedUnitTypes = this.availableUnitTypes.filter((x) =>
      ids.includes(x.accomodationUnitTypeId)
    );
    this.initialSelectedUnitTypes = this.availableUnitTypes.filter((x) =>
      ids.includes(x.accomodationUnitTypeId)
    );
  }

  areNewAUTsSelected(
    initialSelectedAUTs: UnitTypeViewModel[],
    selectedAUTs: UnitTypeViewModel[]
  ) {
    const existingAUTIds = initialSelectedAUTs.map(
      (x) => x.accomodationUnitTypeId
    );
    const newAUTIds = selectedAUTs.map((x) => x.accomodationUnitTypeId);

    if (newAUTIds.length > existingAUTIds.length) return true;

    if (newAUTIds.some((x) => !existingAUTIds.includes(x))) return true;

    return false;
  }

  //#endregion

  //#region occupancy based rules
  occupancyBasedRules = [] as RatePlanOccupancyBasedRule[];
  occupancyBasedRulesFilter = "";

  occupancyBasedRulesHeaders = [
    ...this.unitTypeHeaders,
    {
      text: "RatePlan.NumberOfOBRs",
      value: "numberOfObrs",
      sortable: false,
      filterable: false,
    },
  ];

  get translatedHeadersObr() {
    return this.occupancyBasedRulesHeaders.map((x) => ({
      ...x,
      text: this.$t(x.text),
    }));
  }

  get groupedOccupancyBasedRules() {
    const filteredUnitTypes = this.occupancyBasedRulesFilter
      ? this.selectedUnitTypes.filter((x) =>
          x.propertyName
            .toLowerCase()
            .includes(this.occupancyBasedRulesFilter.toLowerCase())
        )
      : this.selectedUnitTypes;

    return filteredUnitTypes.map((x) => {
      return {
        accomodationUnitTypeId: x.accomodationUnitTypeId,
        name: x.name,
        propertyName: x.propertyName,
        occupancyBasedRules: this.occupancyBasedRules
          .filter((r) => r.accomodationUnitTypeId === x.accomodationUnitTypeId)
          .sort((a, b) => a.minPersons - b.minPersons),
      };
    });
  }

  get ratePlanAccUnitTypesWithObRulesCount() {
    return this.selectedUnitTypes.filter((x) => x.paxlosCombinations.length > 1)
      .length;
  }

  // map occupancy based rules whenever the list of selected unit types changes
  // any rules which are already in the list are kept as-is when new unit types are selected
  // if the rate plan has any rules fetched from the server when the form is opened they are added to the list as-is when their unit type is selected
  @Watch("selectedUnitTypes", { deep: true, immediate: true })
  selectedUnitTypesOccupancyBasedRulesWatch(fresh: UnitTypeViewModel[]) {
    if (fresh.length === 0) {
      this.occupancyBasedRules = [];
      return;
    }

    let existingRules = _.cloneDeep(this.occupancyBasedRules);
    const selectedUnitsIds = fresh.map((x) => x.accomodationUnitTypeId);
    existingRules = existingRules.filter((x) =>
      selectedUnitsIds.includes(x.accomodationUnitTypeId)
    );

    const allRules = fresh.flatMap((ut) =>
      ut.paxlosCombinations.map((c) => {
        return {
          id: -1,
          accomodationUnitTypeId: ut.accomodationUnitTypeId,
          accomodationUnitTypesPAXCategoryId:
            c.accomodationUnitTypesPAXCategoryId,
          accomodationUnitTypesLOSCategoryId:
            c.accomodationUnitTypesLOSCategoryId,
          minPersons: c.minPersons,
          maxPersons: c.maxPersons,
          minStay: c.minStay,
          maxStay: c.maxStay,
          priceDifference: null,
          priceDifferenceIsAbsolute: null,
          isDefault: c.isDefault,
        } as RatePlanOccupancyBasedRule;
      })
    );

    if (this.ratePlan.ratePlanAccomodationUnitTypes.length !== 0) {
      this.ratePlan.ratePlanAccomodationUnitTypes.forEach((rput) => {
        const rule = allRules.find(
          (r) =>
            r.accomodationUnitTypeId === rput.accomodationUnitTypeId &&
            r.accomodationUnitTypesPAXCategoryId ===
              rput.accomodationUnitTypesPAXCategoryId &&
            r.accomodationUnitTypesLOSCategoryId ===
              rput.accomodationUnitTypesLOSCategoryId
        );

        if (rule) {
          rule.id = rput.id;
          rule.priceDifference = rput.priceDifference;
          rule.priceDifferenceIsAbsolute = rput.priceDifferenceIsAbsolute;
        }
      });
    }

    this.occupancyBasedRules = _.unionBy(
      existingRules,
      allRules,
      (x) =>
        `${x.id}_${x.accomodationUnitTypeId}_${x.accomodationUnitTypesPAXCategoryId}_${x.accomodationUnitTypesLOSCategoryId}`
    );
  }
  //#endregion

  //#region helper functions
  close() {
    this.rightDrawer?.clickOverlay();
  }

  resetDerivedPlanValues() {
    this.ratePlan.parentRatePlanId = undefined;
    this.ratePlan.priceDifferenceIsAbsolute = undefined;
    this.ratePlan.priceDifference = undefined;
  }

  // scroll to add on services when opened
  servicesPanelOpened(index: number) {
    if (index === 0) {
      setTimeout(() => {
        const x = this.$refs.servicesPanel as any;
        x.$el.scrollIntoView({ behavior: "smooth" });
      }, 350);
    }
  }

  //#endregion
}
